import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ApiModulesService } from '../services/api-modules.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sso-widjet',
  templateUrl: './sso-widjet.component.html',
  styleUrls: ['./sso-widjet.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class SsoWidjetComponent implements OnInit {
  token: string;
  loginData: any
  private freshwork_domain = environment.fresh_work_api;

  constructor(private apiModulesService: ApiModulesService, private activatedRoute: ActivatedRoute, private router: Router) {
  }
  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      localStorage.setItem('token', params.get('token'));
      localStorage.setItem('is_first_login', 'true');
      window.location.href = this.freshwork_domain;
    });

  }
}
